module.exports = __webpack_public_path__ + "img/logo-dash.d783351e.png";